import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Star } from "lucide-react";

let cache = null;
const getMembers = () => (cache ||= api.get("/fanclub/members").then((r) => new Set(r.data.user_ids)).catch(() => new Set()));

export const useFanMembers = () => { const [m, setM] = useState(null); useEffect(() => { getMembers().then(setM); }, []); return m; };

export const FanBadge = ({ userId }) => {
  const members = useFanMembers();
  if (!userId || !members?.has(userId)) return null;
  return <span className="inline-flex items-center gap-0.5 text-[10px] font-bold px-1.5 py-0.5 rounded-full bg-amber-400/15 border border-amber-400/50 text-amber-200" title="GIG LIFE Digital Fan Club member" data-testid={`fan-badge-${userId}`}><Star className="w-3 h-3" />GIG LIFE</span>;
};
